import React from "react";

const Testament = () => {
  return null;
};

export default Testament;
